export default __webpack_public_path__ + "static/media/clinet51.7a161999.png";